/* BD Maschine zuerst 24.09.2026
 * Alt: Zubehörpreise und pauschaler Abschlag als Zahlen im Skript.
 * Neu: Rechnet in Cent mit tatsächlich gerenderten Shopify-Varianten und Stückzahlen.
 * Grund: Eine Preisquelle für Anzeige, Gesamtsumme und Anfrage; Initialisierung bei Annäherung. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.bdReady) return;
    root.dataset.bdReady = 'true';
    var variant = root.querySelector('#bdVariant');
    if (!variant) return;
    var fmt = new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'});
    var money = function (cents) { return fmt.format(cents / 100); };
    var options = Array.from(root.querySelectorAll('.bd-opt'));
    var batterySelected = false;
    function cents(el) { var n = Number(el.dataset.priceCents); return Number.isFinite(n) && n > 0 ? Math.round(n) : 0; }
    function selectedVariant() { return variant.options[variant.selectedIndex]; }
    function syncBattery() {
      var match = (selectedVariant().dataset.title || '').match(/(\d+)\s*Watt/i);
      var key = match && Number(match[1]) >= 500 ? 'battery_high' : 'battery_low';
      root.querySelectorAll('[data-bd-battery]').forEach(function (row) {
        var visible = row.dataset.bdBattery === key;
        row.hidden = !visible;
        var input = row.querySelector('input');
        input.disabled = !visible;
        input.checked = visible && batterySelected;
      });
    }
    function summaryValue() {
      return root.dataset.productTitle + ' — ' + (selectedVariant().dataset.title || '') + ' :: ' + (root.dataset.items || '(nur Maschine)') + ' — Gesamt netto ' + money(Number(root.dataset.totalCents || 0));
    }
    function syncFormConfiguration() {
      document.querySelectorAll('#bd21-machine-lead-form, form[data-bd-callback-contact]').forEach(function (form) {
        var field = form.querySelector('input[name="contact[konfiguration]"]');
        if (field) field.value = summaryValue();
      });
    }
    function line(label, amount) {
      var row = document.createElement('div'); row.className = 'bd-line';
      var text = document.createElement('span'); text.textContent = label;
      var price = document.createElement('span'); price.textContent = money(amount);
      row.append(text, price); return row;
    }
    function recalc() {
      syncBattery();
      var base = cents(selectedVariant()), accessory = 0, items = [];
      options.filter(function (el) { return el.checked && !el.disabled; }).forEach(function (el) {
        var price = cents(el); accessory += price;
        items.push(el.dataset.name + ' [Variante ' + el.dataset.variantId + ', SKU ' + (el.dataset.sku || '—') + '] = ' + money(price));
      });
      var total = base + accessory;
      var lines = root.querySelector('#bdLines');
      lines.replaceChildren(line('Maschine: ' + (selectedVariant().dataset.title || ''), base), line('Ausgewähltes Zubehör', accessory));
      root.querySelector('#bdTotal').textContent = money(total);
      root.dataset.totalCents = String(total);
      root.dataset.total = (total / 100).toFixed(2);
      root.dataset.items = items.join(' | ');
      syncFormConfiguration();
    }
    options.forEach(function (input) {
      input.addEventListener('change', function () { if (input.hasAttribute('data-bd-battery-input')) batterySelected = input.checked; recalc(); });
    });
    variant.addEventListener('change', recalc);
    root.querySelectorAll('.bd-card').forEach(function (card) { if (!card.querySelector('.bd-opt')) card.hidden = true; });
    root.querySelector('#bdPreset').addEventListener('click', function () { batterySelected = true; options.forEach(function (input) { input.checked = !input.disabled; }); recalc(); });
    root.querySelector('#bdReset').addEventListener('click', function () { batterySelected = false; options.forEach(function (input) { input.checked = false; }); recalc(); });
    root.querySelector('#bdRequest').addEventListener('click', function () {
      var form = document.querySelector('#bd21-machine-lead-form') || document.querySelector('form[data-bd-callback-contact]');
      if (form) {
        var field = form.querySelector('input[name="contact[konfiguration]"]');
        if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'contact[konfiguration]'; form.appendChild(field); }
        field.value = summaryValue();
        form.scrollIntoView({behavior: 'smooth', block: 'start'});
        var first = form.querySelector('input:not([type="hidden"]):not([disabled])');
        if (first) first.focus({preventScroll: true});
      } else {
        window.location.href = '/pages/kontakt?thema=konfiguration&produkt=' + encodeURIComponent(root.dataset.productHandle) + '&konfiguration=' + encodeURIComponent(summaryValue());
      }
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({event: 'beamdeals_configurator_request', geraet: selectedVariant().dataset.title, summe: root.dataset.total}); } catch (e) {}
    });
    recalc();
  }
  document.querySelectorAll('[data-bd-configurator]').forEach(function (root) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) { observer.disconnect(); init(root); }
      }, {rootMargin: '400px'});
      observer.observe(root);
      root.addEventListener('focusin', function () { observer.disconnect(); init(root); }, {once: true});
      root.addEventListener('pointerdown', function () { observer.disconnect(); init(root); }, {once: true});
    } else init(root);
  });
})();
